<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-list-item-avatar class="mr-3" v-bind="attrs" v-on="on">
        <img v-if="$store.state.user.islogin" :src="user.avatar" />
        <v-btn v-else icon><v-icon>mdi-account-circle</v-icon></v-btn>
      </v-list-item-avatar>
    </template>

    <v-card>
      <v-list>
        <v-list-item>
          <a href="https://cn.gravatar.com/emails/" target="_blank">
            <v-list-item-avatar>
              <img :src="user.avatar" />
            </v-list-item-avatar>
          </a>
          <v-list-item-content>
            <v-list-item-title>{{ user.message }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="userlogin" color="link" text>{{ user.btn }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import login from "@/networker/login";
export default {
  methods: {
    userlogin() {
      if (this.$store.state.user.islogin) {
        this.$store.commit("userLoginOut");
        //在服务器退出登录
        login.loginOut().then();
        //刷新页面,以保证页面正常退出
        this.$router.go(0);
      } else {
        this.value = false;
        this.$router.push("/login");
      }
    },
  },
  computed: {
    user: {
      get: function () {
        let data = {};
        if (this.$store.state.user.islogin) {
          data.message = "当前用户：" + this.$store.state.user.userinfo.name;
          data.btn = "退出登录";
          data.avatar = this.$store.state.user.userinfo.avatar;
        } else {
          data.message = "当前用户：未登录";
          data.btn = "登录";
          data.avatar = require("@/assets/def-avatar.png");
        }
        return data;
      },
    },
  },
};
</script>

<style></style>
